// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.minHeight(BrowserStyle.vh(100.0)),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.vw(100.0)),
            tl: /* [] */0
          }
        }
      }
    });

var innerContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.minWidth(BrowserStyle.rem(20.0)),
        tl: {
          hd: BrowserStyle.maxWidth(BrowserStyle.rem(20.0)),
          tl: {
            hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
            tl: /* [] */0
          }
        }
      }
    });

var logo = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XLarge */5, /* Bold */2);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.textAlign(BrowserStyle.center),
          tl: /* [] */0
        }));

var subtitle = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.textAlign(BrowserStyle.center),
          tl: /* [] */0
        }));

var Styles = {
  container: container,
  innerContainer: innerContainer,
  logo: logo,
  title: title,
  subtitle: subtitle
};

function WebComponents_SimpleCenteredLogoPage(Props) {
  var children = Props.children;
  var subtitle$1 = Props.subtitle;
  var title$1 = Props.title;
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container,
              children: React.createElement(BrowserComponents_FlexColumn.make, {
                    className: innerContainer,
                    children: null
                  }, React.createElement(BrowserComponents_Image.make, {
                        className: logo,
                        image: {
                          TAG: /* Logo */2,
                          _0: /* Dark */4
                        }
                      }), Relude_Option.fold(null, (function (title$2) {
                          return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                          size: /* XXLarge */7
                                        }), React.createElement(BrowserComponents_Text.make, {
                                          className: title,
                                          children: title$2
                                        }));
                        }), title$1), Relude_Option.fold(null, (function (subtitle$2) {
                          return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                          size: Relude_Option.fold(/* XXLarge */7, (function (param) {
                                                  return Relude_Globals.$$const(/* Small */3, param);
                                                }), title$1)
                                        }), React.createElement(BrowserComponents_Text.make, {
                                          className: subtitle,
                                          children: subtitle$2
                                        }));
                        }), subtitle$1), Relude_Option.fold(null, (function (children) {
                          return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                          size: /* XXLarge */7
                                        }), children);
                        }), children))
            });
}

var make = WebComponents_SimpleCenteredLogoPage;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
